import React, { useState } from "react";
import logo from "../Assets/logo_black.png"; // Corrige la ruta de importación
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Navbar.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  const handleChatBtnClick = () => {
    if (!isButtonDisabled) {
      toast.info("Experiencing high traffic, Please wait a moment.", {
        position: toast.POSITION.TOP_CENTER,
        onOpen: () => setIsButtonDisabled(true),
        onClose: () => setIsButtonDisabled(false),
      });
    }
  };

  return (
    <div className="navbar-section">
      <h1 className="navbar-title">
      <img 
              src={logo} 
              alt="Legal Services Logo" 
              className="ft-logo" 
              style={{ width: '103px', height: 'auto', verticalAlign: 'middle' }} 
            /> 
      </h1>

      {/* Desktop */}
      <ul className="navbar-items">
        <li>
          <Link to="/" className="navbar-links">
            Inicio
          </Link>
        </li>
        <li>
          <a href="#services" className="navbar-links">
            ¿En qué destacamos?
          </a>
        </li>
        <li>
          <a href="#about" className="navbar-links">
            Sobre nosotros
          </a>
        </li>
      
        
      </ul>

      <button
        className="navbar-btn"
        type="button"
        disabled={isButtonDisabled}
        
      >
    
      </button>

      {/* Mobile */}
      <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
        <div onClick={openNav} className="mobile-navbar-close">
          <FontAwesomeIcon icon={faXmark} className="hamb-icon" />
        </div>

        <ul className="mobile-navbar-links">
          <li>
            <Link onClick={openNav} to="/">
              Inicio
            </Link>
          </li>
          <li>
            <a onClick={openNav} href="#services">
            ¿En qué destacamos?
            </a>
          </li>
          <li>
            <a onClick={openNav} href="#about">
            Sobre nosotros
            </a>
          </li>
         
         
          <li>
            <a onClick={openNav} href="#contact">
              Contáctanos
            </a>
          </li>
        </ul>
      </div>

      {/* Hamburger Icon */}
      <div className="mobile-nav">
        <FontAwesomeIcon
          icon={faBars}
          onClick={openNav}
          className="hamb-icon"
        />
      </div>
    </div>
  );
}

export default Navbar;
